import type { CouponRecord } from '@navio/nsdk';
import { NoddiBadge } from 'noddi-ui-web';
import { COUPON_SOURCE_LABEL, couponSourceKind, couponSourceSecondary } from './Coupon/couponSourceCopy';

type Props = {
  coupon: CouponRecord;
};

export const CouponSourceCell = ({ coupon }: Props) => {
  const kind = couponSourceKind(coupon);
  const secondary: string | null = couponSourceSecondary(coupon);

  return (
    <div className='flex min-w-0 flex-col gap-0.5'>
      <NoddiBadge variant='outline'>{COUPON_SOURCE_LABEL[kind]}</NoddiBadge>
      {secondary && <span className='truncate text-xs text-muted-foreground'>{secondary}</span>}
    </div>
  );
};
